import React from 'react'
import { Col, Row, Table } from 'react-bootstrap';
import { formatCurrency } from '../../util/Currency';
import { formatDate } from '../../util/Date';
import { getBillStatus } from '../../util/Lookup';
import { evenRound } from '../../util/NumberUtils';
import { formatPhone } from 'util/Phone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';


const BillDetail = (props) => {
    const businessConfig = props.businessConfig;
    const bill = props.bill;
    const account = props.account;
    const accountTypeName = props.accountTypeName;
    const logoImage = process.env.REACT_APP_BASE_API_URL + "/businesses/brandelements/logo"
    let totalTaxes = 0.0;
    let preTaxSubTotal = 0.0;
    return (
        <>
            <Row>
                <Col mb={7} lg={7} sm={7}>
                    <div>
                        <img src={logoImage} alt="..." height={businessConfig.logoHeight} width={businessConfig.logoWidth} />
                    </div>
                </Col>
                <Col mb={5} lg={5} sm={5} className="container d-flex justify-content-end">
                    <Table size="sm" striped={false} borderless={true} className="container d-flex justify-content-end"> 
                        <tbody>
                            <tr className='m-0 p-0'><td className='m-0 p-0'>{businessConfig.name}</td></tr>
                            {(businessConfig.type === 'NON_PROFIT') && <tr className='m-0 p-0'><td className='m-0 p-0'><b>Charity Number:</b> {businessConfig.charityNumber}</td></tr>}
                            <tr><td className='m-0 p-0'>{businessConfig.address}</td></tr>
                            <tr><td className='m-0 p-0'>{businessConfig.city}, {businessConfig.state}, {businessConfig.zip}</td></tr>
                            <tr><td className='m-0 p-0'><FontAwesomeIcon icon={faPhone} /> {formatPhone(businessConfig.phoneNumber)}</td></tr>
                        </tbody>    
                    </Table>

                </Col>
            </Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>
                <Col>
                    <h6>Billed To</h6><br />
                    {account.firstName} {account.lastName}<br />
                    {account.address}<br />
                    {account.city}, {account.state}, {account.zip}<br />
                    <FontAwesomeIcon icon={faPhone} /> {formatPhone(account.mobilePhoneNumber)}<br/>
                    <FontAwesomeIcon icon={faEnvelope} /> {account.email}

                </Col>
                <Col>
                    {bill.receiptNumber && <><h6>Receipt Number</h6> {bill.receiptNumber}
                    <br /><br /></>}
                    <h6>Date of Issue</h6> {formatDate(bill.billDate)}
                    <br /><br />
                    <h6>Due Date:</h6> {formatDate(bill.dueDate)}
                </Col>
                <Col>
                    <h6>Bill Number</h6> {bill.billNumber}
                    <br /><br />
                    <h6>Account Number</h6>  {account.number}
                    <br /><br />
                    <h6>Account Type</h6> {accountTypeName}
                </Col>
                <Col>
                    <h6>Amount Due</h6><h3>{formatCurrency(bill.amountDue / 100, businessConfig.locale, businessConfig.currency)}</h3>
                    <h6>Bill Status</h6><h3>{getBillStatus(bill.billStatus)}</h3>
                </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>

            <Row>
                <Col>Line Item Description</Col>
                <Col>Rate</Col>
                <Col>Quantity</Col>
                <Col>Total</Col>
                <Col>Taxes</Col>
                <Col>Line Total</Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            {bill.lineItems.map((billLineItem, idx) => {

                let lineItemAmount = billLineItem.lineItemAmount;
                let lineItemQuantity = billLineItem.quantity;
                let lineTotalTaxes = billLineItem.taxable?parseFloat(lineItemAmount) * parseFloat(lineItemQuantity) * parseFloat(businessConfig.salesTaxRate):0;
                totalTaxes = parseFloat(totalTaxes) + parseFloat(lineTotalTaxes);
                let preTaxLineTotal = parseFloat(lineItemAmount) * parseFloat(lineItemQuantity);
                let lineItemTotal = preTaxLineTotal + lineTotalTaxes;
                preTaxSubTotal = parseFloat(preTaxSubTotal) + preTaxLineTotal;

                return (

                    <Row key={idx}>
                        <Col>
                            <h6>{billLineItem.lineItemDescription}</h6>
                        </Col>
                        <Col>
                            {formatCurrency(evenRound(lineItemAmount/100,2), businessConfig.locale, businessConfig.currency)}
                        </Col>
                        <Col>
                            {lineItemQuantity}
                        </Col>
                        <Col>
                            {formatCurrency(evenRound(preTaxLineTotal/100,2), businessConfig.locale, businessConfig.currency)}
                        </Col>
                        <Col>
                            {formatCurrency(evenRound(lineTotalTaxes/100, 2), businessConfig.locale, businessConfig.currency)}
                        </Col>
                        <Col>
                            {formatCurrency(evenRound(lineItemTotal/100, 2), businessConfig.locale, businessConfig.currency)}
                        </Col>

                    </Row>
                )
            })}
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <h6>SubTotal</h6>
                </Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>
                    {formatCurrency(evenRound(preTaxSubTotal/100,2), businessConfig.locale, businessConfig.currency)}
                </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <h6>Total Taxes</h6>
                </Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>
                    {formatCurrency(evenRound(totalTaxes/100,2), businessConfig.locale, businessConfig.currency)}
                </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <h6>Total Amount Due</h6>
                </Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>
                    {formatCurrency(bill.amountDue / 100, businessConfig.locale, businessConfig.currency)}
                </Col>
            </Row>

        </>
    )
}

export default BillDetail